import { constants as clientConstants, reducer as clientReducer } from 'mage-client'
import { constants as configConstants, reducer as configReducer } from 'mage-config'
import { constants as conversationConstants, reducer as conversationReducer } from 'mage-conversation'
import { constants as coreConstants, reducer as coreReducer } from 'mage-core'
import { constants as experimentationConstants, reducer as experimentationReducer } from 'mage-experimentation'
import { constants as i18nConstants, reducer as i18nReducer } from 'mage-i18n'
import { constants as notificationsConstants, reducer as notificationsReducer } from 'mage-notifications'
import { constants as educationConstants, reducer as educationReducer } from 'education-tools'
import { constants as cmsConstants, reducer as cmsReducer } from 'mage-cms'
import { connectRouter } from 'mage-deps/connected-react-router'

export default (history, reducers) => ({
  router: connectRouter(history),
  [configConstants.NAME]: configReducer,
  [coreConstants.NAME]: coreReducer,
  [i18nConstants.NAME]: i18nReducer,
  [experimentationConstants.NAME]: experimentationReducer,
  [conversationConstants.NAME]: conversationReducer,
  [notificationsConstants.NAME]: notificationsReducer,
  [educationConstants.NAME]: educationReducer,
  [cmsConstants.NAME]: cmsReducer,
  [clientConstants.NAME]: clientReducer,
  ...reducers()
})
